const PAGE_HEADER_OCR = 'page-header-ocr';

const FONT_SIZE = 16;
const MIN_FONT_SIZE = 10;

const PageHeaderOcr = ({ pageNumber, scaleWithZoom }) => {
  const dynamicFontSize = Math.max(MIN_FONT_SIZE, FONT_SIZE * scaleWithZoom);
  const circleSize = dynamicFontSize * 2.2;
  const horizontalPadding = dynamicFontSize * 0.5;

  return (
    <div
      style={{
        fontSize: `${dynamicFontSize}px`,
        width: `${circleSize}px`,
        height: `${circleSize}px`,
        lineHeight: `${circleSize}px`,
        paddingLeft: `${horizontalPadding}px`,
        paddingRight: `${horizontalPadding}px`,
      }}
      className={`${PAGE_HEADER_OCR}--header`}
    >
      {pageNumber}
    </div>
  );
};
export default PageHeaderOcr;
